import { homeAtom } from "@/atoms/home.ts";
import VendorLayout from "./VendorLayout/index.tsx";
import TestTips1 from "@/components/TestTips1/index.tsx";

const HomeDefault: React.FC = () => {
  console.log("HomeDefault组件渲染");
  const { pathname } = useLocation();

  // 组件生命周期
  useScrollCenter('div[data-path="/home"]');

  const fetchHomeData = useSetAtom(homeAtom);
  useEffect(() => {
    fetchHomeData(pathname);
  }, []);

  console.log("vivo小米ui----已完成");
  return (
    <>
      <TestTips1 />
      <VendorLayout />
    </>
  );
};

export default HomeDefault;
